export default __webpack_public_path__ + "static/cashflow 202-19998a9033cbfdb5898fdb087b1c1b0a.png";